// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-table-bar {
  position: relative;
  left: calc(-1 * var(--chartkit-bg-bar-offset-width) / 2);
  margin-right: calc(-1 * var(--chartkit-bg-bar-offset-width));
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: calc(100% + var(--chartkit-bg-bar-offset-width));
  padding-right: 5px;
  z-index: 0;
}
.chartkit-table-bar__block {
  position: absolute;
  z-index: -1;
  left: 0;
  text-align: left;
  height: var(--dl-table-cell-bar-height, 19px);
}
.chartkit-table-bar__separator {
  position: absolute;
  display: inline-block;
  width: 0;
  height: 130%;
  border-right: 1px solid var(--g-color-text-complementary);
  margin-top: calc(-0.15 * var(--dl-table-cell-bar-height, 19px));
}

:root {
  --chartkit-bg-bar-offset-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/Widget/components/Table/Bar/Bar.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,wDAAA;EACA,4DAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uDAAA;EACA,kBAAA;EACA,UAAA;AACJ;AACI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,6CAAA;AACR;AAEI;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,yDAAA;EACA,+DAAA;AAAR;;AAIA;EAMI,iCAAA;AANJ","sourcesContent":[".chartkit-table-bar {\n  position: relative;\n  left: calc(-1 * var(--chartkit-bg-bar-offset-width) / 2);\n  margin-right: calc(-1 * var(--chartkit-bg-bar-offset-width));\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: calc(100% + var(--chartkit-bg-bar-offset-width));\n  padding-right: 5px;\n  z-index: 0;\n}\n.chartkit-table-bar__block {\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  text-align: left;\n  height: var(--dl-table-cell-bar-height, 19px);\n}\n.chartkit-table-bar__separator {\n  position: absolute;\n  display: inline-block;\n  width: 0;\n  height: 130%;\n  border-right: 1px solid var(--g-color-text-complementary);\n  margin-top: calc(-0.15 * var(--dl-table-cell-bar-height, 19px));\n}\n\n:root {\n  --chartkit-bg-bar-offset-width: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
